module.exports = __webpack_public_path__ + "img/lines-background.d1b5ab60.png";